import { 
  Gift, 
  Cake, 
  Bell, 
  Heart, 
  Sparkles, 
  Star, 
  Home, 
  Music, 
  Laptop, 
  Coffee, 
  Camera, 
  Plane, 
  Gamepad, 
  Palette,
  Trees,
  Sparkle,
  BookOpen,
  Dumbbell,
  ShoppingBag,
  Baby,
  Dog,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface WishlistIcon {
  id: string;
  icon: LucideIcon;
  /** i18n ключ для label (например, 'icons.gift') */
  labelKey: string;
  emoji: string;
}

export const WISHLIST_ICONS: WishlistIcon[] = [
  { id: 'gift', icon: Gift, labelKey: 'common:icons.gift', emoji: '🎁' },
  { id: 'cake', icon: Cake, labelKey: 'common:icons.cake', emoji: '🎂' },
  { id: 'trees', icon: Trees, labelKey: 'common:icons.trees', emoji: '🎄' },
  { id: 'sparkle', icon: Sparkle, labelKey: 'common:icons.sparkle', emoji: '💅' },
  { id: 'home', icon: Home, labelKey: 'common:icons.home', emoji: '🏠' },
  { id: 'sparkles', icon: Sparkles, labelKey: 'common:icons.sparkles', emoji: '✨' },
  { id: 'bell', icon: Bell, labelKey: 'common:icons.bell', emoji: '🔔' },
  { id: 'heart', icon: Heart, labelKey: 'common:icons.heart', emoji: '❤️' },
  { id: 'star', icon: Star, labelKey: 'common:icons.star', emoji: '⭐' },
  { id: 'music', icon: Music, labelKey: 'common:icons.music', emoji: '🎵' },
  { id: 'laptop', icon: Laptop, labelKey: 'common:icons.laptop', emoji: '💻' },
  { id: 'coffee', icon: Coffee, labelKey: 'common:icons.coffee', emoji: '☕' },
  { id: 'camera', icon: Camera, labelKey: 'common:icons.camera', emoji: '📷' },
  { id: 'plane', icon: Plane, labelKey: 'common:icons.plane', emoji: '✈️' },
  { id: 'gamepad', icon: Gamepad, labelKey: 'common:icons.gamepad', emoji: '🎮' },
  { id: 'palette', icon: Palette, labelKey: 'common:icons.palette', emoji: '🎨' },
  { id: 'book', icon: BookOpen, labelKey: 'common:icons.book', emoji: '📚' },
  { id: 'fitness', icon: Dumbbell, labelKey: 'common:icons.fitness', emoji: '💪' },
  { id: 'shopping', icon: ShoppingBag, labelKey: 'common:icons.shopping', emoji: '🛍️' },
  { id: 'baby', icon: Baby, labelKey: 'common:icons.baby', emoji: '👶' },
  { id: 'pet', icon: Dog, labelKey: 'common:icons.pet', emoji: '🐶' },
];

export const DEFAULT_ICON_ID = 'gift';